import React, { Component } from 'react';
import Weather from 'components/weather'
import {
    Switch,
    Route,
    Redirect,
} from 'react-router-dom'
import LocationPickerView from 'components/locationPickerView'
import LoaderView from 'components/loaderView'
import VersionManager from 'manager/versionManager'
import Analytics from './analytics'
import UserIdManager from 'manager/userIdManager'
import Constants from 'common/constants'

class App extends Component {
    constructor(props) {
        super(props);
        this.initialiseGPT();
    }

    handleAdsImpression = (event) => {
        let slot = event.slot.getAdUnitPath();
        if (slot.includes('/')) {
            let list = slot.split('/')
            slot = list[list.length - 1]
        }

        console.log('Impression for slot', slot, 'became viewable.');
        Analytics.sendEventWithObjParams({
            category: Constants.ANALYTICS.EVENTS.CATEGORY.WEATHER_PAGE,
            action: Constants.ANALYTICS.EVENTS.ACTION.DFP_ADS_IMPRESSION,
            label: slot,
            ad_source: this.getAdSource(slot)
        })
    }

    getAdSource(slot){
        switch(slot){
            case 'WeatherPort-MobileApp-MinusOne-320x50' : 
                return Constants.ANALYTICS.EVENTS.CATEGORY.AD_ABOVE_FOLD
            case 'weatherportminusoneSecondFold' : 
                return Constants.ANALYTICS.EVENTS.CATEGORY.AD_SECOND_FOLD
            default : 
              return Constants.ANALYTICS.EVENTS.CATEGORY.WEATHER_PAGE       
        }
    }

    initialiseGPT() {
        const script = document.createElement("script");
        script.src = "https://securepubads.g.doubleclick.net/tag/js/gpt.js";
        script.async = true;
        document.body.appendChild(script);
        window.googletag = window.googletag || { cmd: [] };
        window.googletag.cmd.push(() => {
            window.topAdSlot = window.googletag.defineSlot('/45361917/WeatherPort-MobileApp-MinusOne-320x50', [320, 100], 'div-gpt-ad-1585573621498-0').addService(window.googletag.pubads());
            window.bottomAdSlot = window.googletag.defineSlot('/45361917/weatherportminusoneSecondFold', [300, 250], 'div-gpt-ad-1591946681893-0').addService(window.googletag.pubads());
            window.googletag.pubads().enableSingleRequest();
            window.googletag.enableServices();
            window.googletag.pubads().addEventListener('impressionViewable', this.handleAdsImpression)
        });
    }

    render() {
        console.info("Web-app version -", VersionManager.getAppVersion())

        // NOTE: Disabling logs throughout the app if not in development
        if (process.env.NODE_ENV !== 'development') {
            console.log = function () { };
            console.debug = function () { };
        }

        // Initialize analytics
        Analytics.initialise()

        // Process user-id
        UserIdManager.sendUserIdToAnalytics()

        return (
            <Switch>
                <Route path='/v1/weather' component={Weather} />
                <Route path='/v1/location' component={LocationPickerView} />
                <Route path='/v1/loading' component={LoaderView} />
                {/* Defaults to redirecting to the main weather page */}
                <Route render={() => (
                    <Redirect to="/v1/weather" />
                )} />
            </Switch>
        )
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js